import { render } from "./free-shipping-indicator.vue?vue&type=template&id=fc4c9e22"
import script from "./free-shipping-indicator.vue?vue&type=script&lang=js"
export * from "./free-shipping-indicator.vue?vue&type=script&lang=js"

import "./free-shipping-indicator.vue?vue&type=style&index=0&id=fc4c9e22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__